<template>
  <span v-if="location || deposit" class="deposit-location-label" :title="accessibleLabel">
    <AppIcon name="warehouse" class="deposit-location-label__deposit-icon" />
    <strong class="deposit-location-label__deposit">{{ depositName }}</strong>
    <template v-if="showLocationPath">
      <AppIcon name="chevron-right" class="deposit-location-label__separator" />
      <span class="deposit-location-label__zone">{{ zoneReference }}</span>
      <AppIcon name="chevron-right" class="deposit-location-label__separator" />
      <span class="deposit-location-label__location">{{ locationReference }}</span>
    </template>
  </span>
</template>

<script>
export default {
  name: 'DepositLocationLabel',
  props: {
    location: {
      type: Object,
      default: null,
    },
    deposit: {
      type: Object,
      default: null,
    },
  },
  computed: {
    zone() {
      return this.location && this.location.zone ? this.location.zone : null
    },
    resolvedDeposit() {
      if(this.deposit) {
        return this.deposit
      }
      return this.zone && this.zone.deposit ? this.zone.deposit : null
    },
    depositName() {
      if(!this.resolvedDeposit) {
        return this.location ? (this.location.full_reference || this.location.reference || this.location.name || '') : ''
      }
      return this.resolvedDeposit.name || this.resolvedDeposit.reference || ''
    },
    zoneReference() {
      return this.zone ? (this.zone.reference || this.zone.name || '') : ''
    },
    locationReference() {
      return this.location ? (this.location.reference || this.location.name || '') : ''
    },
    showLocationPath() {
      if(!this.zone || !this.resolvedDeposit) {
        return false
      }
      return !(
        this.location.full_reference &&
        this.depositName &&
        this.location.full_reference === this.depositName
      )
    },
    accessibleLabel() {
      if(!this.showLocationPath) {
        return this.depositName
      }
      return [this.depositName, this.zoneReference, this.locationReference].filter(Boolean).join(' / ')
    },
  },
}
</script>

<style scoped>
.deposit-location-label {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  color: var(--app-color-text, #26364a);
  white-space: nowrap;
}

.deposit-location-label__deposit-icon {
  margin-right: 4px;
  color: var(--primary);
}

.deposit-location-label__deposit {
  overflow: hidden;
  text-overflow: ellipsis;
}

.deposit-location-label__separator {
  margin: 0 3px;
  color: var(--app-color-text-muted, #718096);
}

.deposit-location-label__zone {
  color: var(--app-color-text-muted, #5f6f82);
}

.deposit-location-label__location {
  color: inherit;
}
</style>
